import { csrfFetch } from '../../store/csrf';
import { setUser, removeUser } from '../actions/userActions'
import { SESSION_LOADED } from '../actions/actionTypes'
import { set2FARequired, verify2FASuccess, verify2FAFail } from '../reducers/twoFactorReducer';


// ****************
export const login = (credentials) => async (dispatch) => {
  const { credential, password } = credentials;

  // console.log('credential', credential);
  // console.log('password', password);

  const response = await csrfFetch('/api/session', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ credential, password }),
  });

  const data = await response.json();

  // console.log('data===>', data);


  // Handle 2FA required (202 from backend)
  if (response.status === 202 && data.requires2FA) {
    dispatch(set2FARequired(data.challengeToken, data.email));
    return { twoFactor: true };
  }



  if (!response.ok) {
    throw new Error(data.message || 'Login failed');
  }

  dispatch(setUser(data));
  return { data };
};

// Request a passwordless admin login link. The backend knows the sole admin's
// address, so the client sends nothing and never sees the email.
export const sendMagicLink = () => async () => {
  const response = await csrfFetch('/api/session/magic-link', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({}),
  });
  return response.json();
};

// Redeem the 6-digit admin login code (the iOS-PWA path — no browser hand-off).
// On success the backend sets the session cookie and returns the user, so we
// drop it into the store and the ProtectedRoute renders /secure in place.
export const submitMagicLinkCode = (code) => async (dispatch) => {
  const response = await csrfFetch('/api/session/magic-link/code', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ code }),
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || 'That code is invalid or has expired.');
  }
  dispatch(setUser(data.user));
  return data;
};

// Staff request a passwordless login link for the /employee dashboard.
export const sendEmployeeMagicLink = (email) => async () => {
  const response = await csrfFetch('/api/session/magic-link/employee', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  });
  return response.json();
};

// Redeem the 6-digit staff login code from inside the PWA. Email is required
// (staff aren't a singleton like the admin). Sets the session on success.
export const submitEmployeeMagicLinkCode = (email, code) => async (dispatch) => {
  const response = await csrfFetch('/api/session/magic-link/employee/code', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, code }),
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || 'That code is invalid or has expired.');
  }
  dispatch(setUser(data.user));
  return data;
};

export const portalLogin = (credentials) => async (dispatch) => {
  const { credential, password } = credentials;
  const response = await csrfFetch('/api/portal/session', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ credential, password }),
  });
  const data = await response.json();

  // Handle 2FA required (202 from backend)
  if (response.status === 202 && data.requires2FA) {
    return { twoFactor: true, challengeToken: data.challengeToken, email: data.email };
  }

  dispatch(setUser(data.user));
  return data;
};

export const verify2FA = (code) => async (dispatch, getState) => {
  const { challengeToken } = getState().twoFactor;

  try {
    const res = await csrfFetch('/api/session/verify-2fa', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code, challengeToken })
    });

    if (!res.ok) {
      const err = await res.json();
      dispatch(verify2FAFail(err.message || 'Invalid 2FA code'));
      return;
    }

    const data = await res.json();

    dispatch({ type: 'session/SET_USER', payload: data.user });
    dispatch(verify2FASuccess());
  } catch (err) {
    console.error(err);
    dispatch(verify2FAFail('2FA verification failed'));
  }
};

// export const login = (credentials) => async (dispatch) => {
//   const { credential, password } = credentials;

//   const response = await csrfFetch('/api/session', {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' }, // Ensure header is set
//     body: JSON.stringify({ credential, password }),
//   });

//   // If the response is not ok, parse the error and throw it.
//   if (!response.ok) {
//     const errorData = await response.json();
//     // You can include additional information from errorData if available.
//     throw new Error(errorData.message || 'Login failed');
//   }

//   // const data = await response.json();
//   const data = await response.json()
  
  
//   // If your API returns a user wrapped in an object, you might want to adjust this:
//   // dispatch(setUser(data.user));
// // console.log('data---> ', data);

//   dispatch(setUser(data));
//   return { data, response };
// };




export const signup = (user) => async (dispatch) => {
  const { firstName, lastName, email, password } = user;
  // console.log(user);

  const response = await csrfFetch("/api/users", {
    method: "POST",
    body: JSON.stringify({
      firstName,
      lastName,
      email,
      password,
    }),
  });


  const data = await response.json();

  // console.log(data);

  dispatch(setUser(data)); 
  return {data, response};
};


export const logout = () => async (dispatch) => {
  const response = await csrfFetch('/api/session', {
    method: 'DELETE',
  });
  dispatch(removeUser());
  return response;
};


export const restoreUser = () => async (dispatch) => {
  try {
    const response = await csrfFetch("/api/session");
    const data = await response.json();

    if (data.user) {
      dispatch(setUser(data.user));
    } else {
      dispatch({ type: SESSION_LOADED });
    }
    return response;
  } catch (err) {
    // 401 means no session — still mark session as loaded so routes can redirect
    dispatch({ type: SESSION_LOADED });
  }
};
